import axios from 'axios';
import type { AxiosError } from 'axios';
import { toast } from '@/hooks/use-toast';
import type { ApiResponse } from '@/types/api';

interface ApiErrorPayload extends Partial<ApiResponse> {
  detail?: string | Array<{ msg?: string }>;
}

/** Extract a user-facing backend message without displaying a toast. */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError<ApiErrorPayload>(error)) {
    const payload = error.response?.data;
    if (payload?.message) return payload.message;
    if (typeof payload?.detail === 'string') return payload.detail;
    if (Array.isArray(payload?.detail)) {
      const validationMessage = payload.detail.find((item) => item.msg)?.msg;
      if (validationMessage) return validationMessage;
    }
    return fallback;
  }

  return error instanceof Error && error.message ? error.message : fallback;
}

/**
 * Parse a backend error response and display it via Toast.
 * Returns the extracted message string for further handling if needed.
 */
export function handleApiError(error: AxiosError<ApiResponse>): string {
  const message = getApiErrorMessage(
    error,
    '网络请求失败，请稍后重试',
  );

  toast({
    variant: 'destructive',
    title: '错误',
    description: message,
  });

  return message;
}
